import { login, register, me } from '../api/auth.js';
import { auth } from './state.js';
import { toast } from '../ui/toast.js';
import { friendlyMessage } from '../api/client.js';

let mode = 'login';   // 'login' | 'register'

function html() {
  return `
    <div class="modal-bg" id="authModal">
      <div class="modal" style="width:380px">
        <h3 id="authTitle">Sign in to GeoDaVerse</h3>
        <form id="authForm" style="display:flex;flex-direction:column;gap:10px;margin-top:6px">
          <label style="font-size:11px;color:var(--text2)">Email
            <input type="email" name="email" required autocomplete="email"
              style="width:100%;margin-top:3px;padding:8px 10px;border-radius:6px;border:1px solid var(--border);background:var(--bg3);color:var(--text);font-size:13px">
          </label>
          <label id="nameField" style="font-size:11px;color:var(--text2);display:none">Full name (optional)
            <input type="text" name="full_name" autocomplete="name"
              style="width:100%;margin-top:3px;padding:8px 10px;border-radius:6px;border:1px solid var(--border);background:var(--bg3);color:var(--text);font-size:13px">
          </label>
          <label style="font-size:11px;color:var(--text2)">Password
            <input type="password" name="password" required minlength="8" autocomplete="current-password"
              style="width:100%;margin-top:3px;padding:8px 10px;border-radius:6px;border:1px solid var(--border);background:var(--bg3);color:var(--text);font-size:13px">
          </label>
          <div id="authError" style="font-size:11.5px;color:var(--red);min-height:14px"></div>
          <button type="submit" id="authSubmit" class="btn btn-primary" style="justify-content:center">Sign in</button>
        </form>
        <p style="font-size:11.5px;color:var(--text3);margin-top:12px;text-align:center">
          <span id="authSwitchPrompt">No account?</span>
          <a href="#" id="authSwitch" style="color:var(--green);text-decoration:none">Create one</a>
        </p>
        <div style="text-align:right;margin-top:10px">
          <button class="btn" data-action="closeAuthModal">Continue as guest</button>
        </div>
        <div style="margin-top:14px;padding-top:12px;border-top:1px solid var(--border);font-family:var(--font-display);font-style:italic;font-size:10.5px;color:var(--text3);text-align:center;letter-spacing:0.02em">
          Designed &amp; powered by
          <strong style="font-style:normal;font-weight:500;color:var(--text2)">Precision GIS and Technology Consultancy Services Ltd</strong>
        </div>
      </div>
    </div>
  `;
}

function ensureMounted() {
  if (document.getElementById('authModal')) return;
  document.body.insertAdjacentHTML('beforeend', html());

  document.getElementById('authSwitch').addEventListener('click', e => {
    e.preventDefault();
    mode = mode === 'login' ? 'register' : 'login';
    syncMode();
  });

  document.getElementById('authForm').addEventListener('submit', onSubmit);
}

function syncMode() {
  document.getElementById('authTitle').textContent =
    mode === 'login' ? 'Sign in to GeoDaVerse' : 'Create your GeoDaVerse account';
  document.getElementById('authSubmit').textContent =
    mode === 'login' ? 'Sign in' : 'Create account';
  document.getElementById('nameField').style.display = mode === 'register' ? 'block' : 'none';
  document.getElementById('authSwitchPrompt').textContent =
    mode === 'login' ? 'No account?' : 'Already have one?';
  document.getElementById('authSwitch').textContent =
    mode === 'login' ? 'Create one' : 'Sign in';
  document.getElementById('authError').textContent = '';
}

async function onSubmit(ev) {
  ev.preventDefault();
  const fd = new FormData(ev.target);
  const email = fd.get('email');
  const password = fd.get('password');
  const full_name = fd.get('full_name') || undefined;

  const errEl = document.getElementById('authError');
  const btn   = document.getElementById('authSubmit');
  errEl.textContent = '';
  btn.disabled = true;
  btn.textContent = mode === 'login' ? 'Signing in…' : 'Creating…';

  try {
    if (mode === 'register') {
      await register({ email, password, full_name });
    }
    const { access_token } = await login({ email, password });
    auth.set(access_token);
    const user = await me();
    auth.setUser(user);
    toast(`Welcome${user.full_name ? `, ${user.full_name}` : ''}`);
    closeAuthModal();
  } catch (e) {
    errEl.innerHTML = `<div class="alert alert-error">${friendlyMessage(e)}</div>`;
  } finally {
    btn.disabled = false;
    btn.textContent = mode === 'login' ? 'Sign in' : 'Create account';
  }
}

export function openAuthModal(initialMode = 'login') {
  ensureMounted();
  mode = initialMode;
  syncMode();
  document.getElementById('authModal').classList.add('show');
  setTimeout(() => document.querySelector('#authForm input[name=email]')?.focus(), 50);
}

export function closeAuthModal() {
  document.getElementById('authModal')?.classList.remove('show');
}

export function logout() {
  auth.clear();
  toast('Signed out');
}
